module.exports = __webpack_public_path__ + "img/special_fog.c4bec9c2.png";